import './style.css';
import tmpl from './main.ejs';

class Adcorner {
    constructor(opt) {
        this.opt = opt;
        this.init(opt)
    };

    init(opt) {
        this.initLayout(opt);
    };

    initLayout({ data }) {
        debugger
        this.data = data;
        const adcorner = {};
        adcorner.img = data.corner_Url[0] || data.corner_Url[1];
        // adcorner.img = data.test[0];
        if (adcorner.img == undefined) {
            this.type = 'off';
            return false;
        }
        this.el = $(tmpl(adcorner));
        this.close = this.el.find('.c-adCorner__close');

    };

    changeImg(type) {
        let img = this.data.corner_Url[type];
        this.el.css("background-image", `url(${img})`);
    };

    hide() {
        this.el.hide();
    };

    show() {
        this.el.show();
    };

    renderTo(parentNode) {
        $(parentNode).append(this.el);
    };

}


export default Adcorner;



// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.component.ad.mobile/app/modules/AdCorner/index.js